import { lazy, Suspense } from 'react';
import { classifyUrl } from './routes';
import { useBrowserLocation } from './browserLocation';
import RouteShell from './RouteShell';

const ShareRoutes = lazy(() => import('./ShareRoutes'));
const SessionRoutes = lazy(() => import('./SessionRoutes'));

export default function AppRouter() {
  const location = useBrowserLocation();
  const route = classifyUrl(location.pathname, location.hash);
  const sharePath = location.hash === '#/share' || location.hash.startsWith('#/share/') ? location.hash.slice(1) : location.pathname;
  if ((sharePath === '/share' || sharePath.startsWith('/share/')) && route.group !== 'share') {
    return <RouteShell notFound />;
  }
  return (
    <Suspense fallback={<RouteShell />}>
      {route.group === 'share'
        ? <ShareRoutes route={route} />
        : <SessionRoutes route={route} />}
    </Suspense>
  );
}